// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"mexico_Tooltip__1vPbK","Indicador":"mexico_Indicador__DNsHP","FadeIn":"mexico_FadeIn__oTc7x","fadeIn":"mexico_fadeIn__16jiW"};